import { uuidv4 } from '@firebase/util';
import { Form } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmModal from '../../../../../common/components/modal/ConfirmModal';
import ErrorNotification from '../../../../../common/components/notification/ErrorNotification';
import MESSAGE, {
    LABEL_MESSAGE,
    NOTIFICATION_TITLE,
} from '../../../../../common/constants/MESSAGE';
import { RootState } from '../../../../../store';
import { ReceivedMoneyOffset, SubCategory } from '../../entity/Entity';
import { CM0012UseCase } from '../../usecase/ServiceImpl';
import {
    setDataLocalCM0012,
    setIsVisibleCM0012,
    setLoadingCM0012,
    setTypeModalCM0012,
} from '../slice/Slice';
import { DataLocal } from '../type/Presenter';
import COMMON from '../../../../../common/constants/COMMON';

const CM0012Handler = (CM0012Service: CM0012UseCase) => {
    // LIB FUNCTION
    const dispatch = useDispatch();

    //STATE
    const [form] = Form.useForm();
    const [isDirty, setIsDirty] = useState(false);

    const [pageOption, setPageOption] = useState(COMMON.DEFAULT_PAGE);
    const [sizeOption, setSizeOption] = useState(COMMON.DEFAULT_SIZE);
    const [totalPage, setTotalPage] = useState<number>();

    const typeModal = useSelector((state: RootState) => state.cm0012.typeModal);
    const parentCode = useSelector((state: RootState) => state.cm0012.parentCode);
    const dataLocal = useSelector((state: RootState) => state.cm0012.dataLocal);

    const [contentDescription, setContentDescription] = useState<any>();
    const [listMoneyDirectCostOutsourceOffset, setListMoneyDirectCostOutsourceOffset] = useState<
        ReceivedMoneyOffset[]
    >([]);
    const [listMoneyDirectCostOutsourceOffsetLocal, setListMoneyDirectCostOutsourceOffsetLocal] =
        useState<ReceivedMoneyOffset[]>([]);

    const [subCategory, setSubCategory] = useState<SubCategory[]>([]);
    const [totalCost, setTotalCost] = useState<number>(0);

    const [defaultCategory, setDefaultCategory] = useState<string>('');
    const [defaultCategoryName, setDefaultCategoryName] = useState<string>('');

    const childFunc = async (
        outsourceCostInformationId: string | number,
        page: number,
        size: number,
    ) => {
        const params = {
            outsourceCostInformationId,
            page,
            size,
        };

        let dataOutput: any[] = [];
        let origin: any = {};

        let stop = true;
        let index = 0;

        do {
            const res = await CM0012Service.getListMoneyDirectCostOutsourceOffset({
                ...params,
                page: params.page + index,
            });

            dataOutput.push(...res.results);
            origin['num'] = res.pagination?.numPages ?? 0;
            origin['startDate'] = res.results?.startDate ?? '';
            origin['endDate'] = res.results?.endDate ?? '';
            origin['orderingCompanyName'] = res.results?.orderingCompanyName ?? '';

            index += 1;

            if (res.results.length === 0) {
                stop = false;
            }
        } while (stop);

        setTotalPage(origin?.numPages ?? 0);
        if (dataOutput.length > 0) {
            const data = formatMoneyDirectCostOutsourceOffset(dataOutput);
            setListMoneyDirectCostOutsourceOffset([...listMoneyDirectCostOutsourceOffset, ...data]);
            setListMoneyDirectCostOutsourceOffsetLocal([
                ...listMoneyDirectCostOutsourceOffsetLocal,
                ...data,
            ]);
            const contentDescription = {
                startDate: origin.startDate,
                endDate: origin.endDate,
                orderingCompanyName: origin.orderingCompanyName,
            };
            setContentDescription(contentDescription);
            const newDataLocal: DataLocal[] = AddDataLocal({
                parentRecordId: parentCode?.parentRecordId,
                arr: [...listMoneyDirectCostOutsourceOffsetLocal, ...data],
            });
            dispatch(setDataLocalCM0012(newDataLocal));
            handleFillForm(data);
        }
    };

    //function
    const handleGetListMoneyDirectCostOutsourceOffset = async (
        outsourceCostInformationId: string | number,
        page: number,
        size: number,
    ): Promise<any> => {
        try {
            dispatch(setLoadingCM0012(true));
            const goal = dataLocal.find(
                (item) => item.parentRecordId === parentCode.parentRecordId,
            );
            if (goal && parentCode?.parentRecordId) {
                if (page === COMMON.DEFAULT_PAGE)
                    getListMoneyDirectCostOutsourceOffsetLocal(parentCode.parentRecordId);
                else {
                    childFunc(outsourceCostInformationId, page, size);
                }
            }
            if (!goal && typeof parentCode?.parentRecordId === 'number') {
                childFunc(outsourceCostInformationId, page, size);
            }
            if (!goal && typeof parentCode?.parentRecordId === 'string')
                setListMoneyDirectCostOutsourceOffsetLocal([]);
        } catch (error: any) {
            ErrorNotification(error?.message ?? NOTIFICATION_TITLE.ERROR);
        } finally {
            dispatch(setLoadingCM0012(false));
        }
    };

    const handleScrollListMoneyDirectCostOutsourceOffset = async (
        e: any,
        outsourceCostInformationId: string | number,
    ): Promise<any> => {
        try {
            const target = e.target;
            if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
                if (totalPage && pageOption + 1 <= totalPage) {
                    setPageOption(pageOption + 1);
                    const data = await handleGetListMoneyDirectCostOutsourceOffset(
                        outsourceCostInformationId,
                        pageOption + 1,
                        sizeOption,
                    );
                }
                if (!totalPage) {
                    setPageOption(pageOption + 1);
                    const data = await handleGetListMoneyDirectCostOutsourceOffset(
                        outsourceCostInformationId,
                        pageOption + 1,
                        sizeOption,
                    );
                }
            }
        } catch (error: any) {
            ErrorNotification(error?.message ?? NOTIFICATION_TITLE.ERROR);
        }
    };

    const getListMoneyDirectCostOutsourceOffsetLocal = (parentRecordId: string | number): void => {
        const res = dataLocal.find((item) => item.parentRecordId === parentRecordId);
        if (res) {
            setListMoneyDirectCostOutsourceOffsetLocal(res.arr);
            handleFillForm(res?.arr);
        }
    };

    const formatMoneyDirectCostOutsourceOffset = (data: any) => {
        const arr: ReceivedMoneyOffset[] = data.map((item: any, index: number) => {
            return {
                key: uuidv4(),
                id: item.id,
                item: item.name,
                taxCategoryComsumptionId: item?.category?.id ?? defaultCategory,
                taxCategoryComsumptionName: item?.category?.description ?? defaultCategoryName,
                offsetAmount: item?.value ?? 0,
            };
        });
        return arr;
    };

    const handleGetSubCategory = async (): Promise<any> => {
        try {
            dispatch(setLoadingCM0012(true));
            const res = await CM0012Service.getSubCategory();
            if (res?.results) {
                setSubCategory(handleFormatSubCategory(res.results));

                const finded = res.results.find((item: any) => item.code === 'tax');

                if (finded) {
                    setDefaultCategory(finded.id);
                    setDefaultCategoryName(finded.description);
                }
            }
        } catch (error: any) {
            ErrorNotification(error?.message ?? NOTIFICATION_TITLE.ERROR);
        } finally {
            dispatch(setLoadingCM0012(false));
        }
    };

    const handleFormatSubCategory = (data: any) => {
        const arr: SubCategory[] = data.map((item: any) => {
            return {
                label: item.description,
                value: item.id,
                code: item.code,
            };
        });
        return arr;
    };

    const handleFillForm = (data: ReceivedMoneyOffset[]) => {
        data.map((item) => {
            form.setFieldValue(`item${item.key}`, item.item);
            form.setFieldValue(`taxCategoryConsumption${item.key}`, item.taxCategoryComsumptionId);
            form.setFieldValue(`offsetAmount${item.key}`, item?.offsetAmount ?? 0);
        });
    };

    const handleCalculateChange = (data: ReceivedMoneyOffset[]) => {
        let total: number = 0;
        data.forEach((item) => {
            const cost = item?.offsetAmount
                ? item.offsetAmount
                : form.getFieldValue(`offsetAmount${item.key}`) ?? 0;
            if (!isNaN(cost)) total += cost;
        });
        setTotalCost(total);
    };

    const handleAddRowLocal = () => {
        const uniqueId = uuidv4();

        const data: ReceivedMoneyOffset = {
            key: uniqueId,
            item: undefined,
            taxCategoryComsumptionId: undefined,
            offsetAmount: undefined,
        };
        setListMoneyDirectCostOutsourceOffsetLocal([
            ...listMoneyDirectCostOutsourceOffsetLocal,
            data,
        ]);
        form.setFieldValue(`taxCategoryConsumption${uniqueId}`, subCategory[0]?.value);
    };

    const handleRemoveRowLocal = (key: string) => {
        if (
            !form.getFieldValue(`item${key}`) &&
            form.getFieldValue(`taxCategoryConsumption${key}`) === subCategory[0]?.value &&
            !form.getFieldValue(`offsetAmount${key}`)
        ) {
            const arr = listMoneyDirectCostOutsourceOffsetLocal.filter((item) => item.key !== key);
            setListMoneyDirectCostOutsourceOffsetLocal([...arr]);
            handleCalculateChange(arr);
            return;
        }
        ConfirmModal({
            onOk: async () => {
                const arr = listMoneyDirectCostOutsourceOffsetLocal.filter(
                    (item) => item.key !== key,
                );
                setListMoneyDirectCostOutsourceOffsetLocal(arr);
                handleCalculateChange(arr);
                setIsDirty(true);
            },
            className: 'confirm__modal',
            title: MESSAGE.MESSAGE_MODAL_DELETE_TITLE,
            description: MESSAGE.MESSAGE_MODAL_DELETE_DESCRIPTION_CM,
            canceText: LABEL_MESSAGE.CANCEL_MODAL,
            okText: LABEL_MESSAGE.OK_MODAL,
            isCenterWithoutMenu: true,
        });
    };

    const handleSubmitForm = async (value: any) => {
        let listData: ReceivedMoneyOffset[] = [];
        listMoneyDirectCostOutsourceOffsetLocal.forEach((item) => {
            listData.push({
                key: item.key + '',
                item: form.getFieldValue(`item${item.key}`),
                taxCategoryComsumptionId:
                    form.getFieldValue(`taxCategoryConsumption${item.key}`) ?? `${defaultCategory}`,
                taxCategoryComsumptionName: form.getFieldValue(`taxCategoryConsumption${item.key}`)
                    ? convertCategoryIdToCategoryName(
                          form.getFieldValue(`taxCategoryConsumption${item.key}`),
                      )
                    : `${defaultCategoryName}`,
                offsetAmount: form.getFieldValue(`offsetAmount${item.key}`) ?? 0,
            });
        });

        const newDataLocal: DataLocal[] = AddDataLocal({
            parentRecordId: parentCode?.parentRecordId,
            arr: listData,
        });
        setListMoneyDirectCostOutsourceOffsetLocal(listData);
        dispatch(setDataLocalCM0012(newDataLocal));
        if (typeof parentCode.parentRecordId === 'number') {
            form.resetFields();
            setIsDirty(false);
            return dispatch(setTypeModalCM0012(false));
        }
        dispatch(setIsVisibleCM0012(false));
        setIsDirty(false);
    };

    const AddDataLocal = (data: DataLocal) => {
        let checkExist = false;
        const arr: DataLocal[] = [];

        dataLocal.forEach((item) => {
            if (item.parentRecordId === data.parentRecordId) {
                arr.push(data);
                checkExist = true;
            } else arr.push(item);
        });
        if (!checkExist) arr.push(data);
        return arr;
    };

    const convertCategoryIdToCategoryName = (id: number) => {
        const res = subCategory.find((item) => item.value === id);
        return res?.label;
    };

    const handleChangeTypeModal = (type: boolean) => {
        if (type) handleFillForm(listMoneyDirectCostOutsourceOffsetLocal);
        dispatch(setTypeModalCM0012(type));
    };

    const checkDirty = (): void => {
        const formValue = form.getFieldsValue();
        const formProps = Object.keys(formValue);
        for (let i = 0; i < formProps.length; i++) {
            if (form.isFieldTouched(formProps[i])) {
                return setIsDirty(true);
            }
        }
        setIsDirty(false);
    };

    const onCancel = () => {
        if (!isDirty) {
            if (!typeModal) dispatch(setIsVisibleCM0012(false));
            else {
                if (typeof parentCode.parentRecordId === 'number') {
                    getListMoneyDirectCostOutsourceOffsetLocal(parentCode.parentRecordId);
                    dispatch(setTypeModalCM0012(false));
                } else dispatch(setIsVisibleCM0012(false));
            }
            return;
        }
        ConfirmModal({
            onOk: async () => {
                if (typeof parentCode.parentRecordId === 'number') {
                    dispatch(setTypeModalCM0012(false));
                    getListMoneyDirectCostOutsourceOffsetLocal(parentCode.parentRecordId);
                } else {
                    const prevData = dataLocal.find(
                        (item) => item.parentRecordId === parentCode.parentRecordId,
                    );
                    if (prevData) {
                        handleCalculateChange(prevData.arr);
                        setListMoneyDirectCostOutsourceOffsetLocal(prevData.arr);
                    }
                    dispatch(setIsVisibleCM0012(false));
                    form.resetFields();
                }
                setIsDirty(false);
            },
            className: 'confirm__modal',
            title: MESSAGE.MESSAGE_020,
            description: MESSAGE.MESSAGE_021,
            canceText: LABEL_MESSAGE.CANCEL_MODAL,
            okText: LABEL_MESSAGE.OK_MODAL,
            isCenterWithoutMenu: true,
        });
    };

    return {
        form,
        typeModal,
        contentDescription,
        listMoneyDirectCostOutsourceOffsetLocal,
        totalCost,
        subCategory,
        onCancel,
        checkDirty,
        handleAddRowLocal,
        handleRemoveRowLocal,
        handleSubmitForm,
        handleCalculateChange,
        handleGetListMoneyDirectCostOutsourceOffset,
        getListMoneyDirectCostOutsourceOffsetLocal,
        handleGetSubCategory,
        handleChangeTypeModal,
        handleScrollListMoneyDirectCostOutsourceOffset,
    };
};

export default CM0012Handler;
